var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 mb-4"},[_c('Header'),(_vm.source.id)?_c('Form',{on:{"saved":_vm.loadData}}):_c('div',{staticClass:"text-center p-5 bg-light"},[_c('b-spinner',{attrs:{"label":"Loading...","variant":"info"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }